import {
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import { AuthService } from '../services/auth.service';

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (
        err.status === 401 &&
        auth.isLoggedIn() &&
        req.url.startsWith(API_BASE_URL)
      ) {
        return from(auth.clear()).pipe(
          switchMap(() => {
            void router.navigate(['/']);
            return throwError(() => err);
          }),
        );
      }
      return throwError(() => err);
    }),
  );
};
